import React, { useState, useEffect } from "react";
import {
  Stack,
  Box,
  Typography,
  Button,
  Snackbar,
  Alert,
  IconButton,
  TextField,
  Tooltip
} from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import { getUserData, addUser, getUserPermissionData } from "../../../store/actions/rolePermissionActions";
import { useDispatch, useSelector } from "react-redux";
import AddUserForm from "./AddUserForm";
import { useHistory } from "react-router-dom"
import PermissionWrapper from "../PermissionWrapper";
export default function UserPage() {
  const dispatch = useDispatch();
  const history = useHistory()
  const [rows, setRows] = useState([
    // { id: 1, name: "Rakesh", email: "rakesh@mail.com", role: "Admin", location: ["Hyderabad"] },
    // { id: 2, name: "Itishree", email: "itishree@mail.com", role: "Manager", location: ["Chennai", "Bangalore"] },
  ]);
  const [filteredRows, setFilteredRows] = useState(rows);
  const [search, setSearch] = useState("");
  const [openForm, setOpenForm] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [snack, setSnack] = useState({ open: false, message: "", severity: "info" });
  const [form, setForm] = useState({ name: "", email: "", roleName: "", allowedLocations: [], defaultLocation: "" });

  useEffect(() => {

    fetchDataFromServer();
  }, []);

  const fetchDataFromServer = () => {

    // setIsLoading(true);
    setSnack({ open: true, message: "loading data from server...!", severity: "info" });
    dispatch(
      getUserData()
    ).then((res) => {
      // setIsLoading(false);
      setRows(res);
      setFilteredRows(res);
      setSnack({ open: false, message: "", severity: "info" });
    });
  };


  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (!value) {
      setFilteredRows(rows);
      return;
    }
    // const filtered = rows.filter((r) =>
    //   [r.name, r.email, r.roleName].some((field) =>
    //     field.toLowerCase().includes(value.toLowerCase())
    //   )
    // );

    const filtered = rows.filter(r =>
      [r.name, r.email, r.roleName].some(field =>
        (field || "").toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredRows(filtered);
  };
  const handleClearSearch = () => {
    setSearch("");
    setFilteredRows(rows);
  };
  const handleAddUser = () => {
    setEditUser(null);
    setForm({ name: "", email: "", roleName: "", allowedLocations: [], defaultLocation: "" });
    setOpenForm(true);
  };
  const handleEditUser = (user) => {
    console.log("user-----------------", user)
    setEditUser(user);
    setForm(user);
    setOpenForm(true);
  };
  const handleDeleteUser = (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      const updated = rows.filter((r) => r.id !== id);
      setRows(updated);
      setFilteredRows(updated);
      setSnack({ open: true, message: "User deleted successfully", severity: "success" });
    }
  };

  const handleSubmitForm = async () => {
    if (!form.name || !form.email || !form.roleName) {
      setSnack({ open: true, message: "Please fill all required fields", severity: "warning" });
      return;
    }
    const transformedPayload = {
      name: form.name,
      email: form.email,
      roleId: form.roleId,
      locationIds: form.allowedLocations.map(Number),
      defaultLocation: Number(form.defaultLocation)
    };
    if (editUser) {
      const res = await dispatch(addUser(transformedPayload, form.id, "edit"))
      const newUser = { id: res?.id, ...form };
      const updated = rows.map(row => row.id === form.id ? newUser : row);
      setRows(updated);
      setFilteredRows(updated);
      setSnack({ open: true, message: "User updated successfully", severity: "success" });
    } else {
      const res = await dispatch(addUser(transformedPayload, "", "add"))
      const newUser = { id: res?.id, ...form };
      const updated = [...rows, newUser];
      setRows(updated);
      setFilteredRows(updated);
      setSnack({ open: true, message: "User added successfully", severity: "success" });
    }
    setOpenForm(false);
  };

  const handleViewPermission = async (userId, userName, userRole) => {
    try {
      setSnack({ open: true, message: "Loading permissions...", severity: "info" });
      const res = await dispatch(getUserPermissionData(userId));
      console.log("Permission data:", res);

      if (res) {
        // Save the permission data to Redux or navigate with state
        // Example: Navigate and send data
        // history.push("/settings/role/permission", { permissionData: res });
        history.push("/settings/role/permission", { permissionData: { data: res?.permissions, details: { type: "User", id: userId, name: userName, roleName: userRole } } });
      }
    } catch (error) {
      console.error("Failed to load permissions:", error);
      setSnack({ open: true, message: "Failed to load permissions", severity: "error" });
    } finally {
      setSnack({ open: false, message: "", severity: "info" });
    }
  };
  const columns = [

    {
      field: "id", headerName: "S.No", width: 90,

      renderCell: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);
        return index + 1;
      }
    },

    { field: "name", headerName: "Name", flex: 1 },
    { field: "email", headerName: "Email", flex: 1.5 },
    { field: "roleName", headerName: "Role", flex: 1 },
    // {
    //   field: "allowedLocations",
    //   headerName: "Locations",
    //   flex: 1.5,
    //   renderCell: (params) => params.value?.join(", "),
    // },

    {
      field: "allowedLocations",
      headerName: "Locations",
      flex: 1.5,
      renderCell: (params) => {
        const locations = params.value || [];
        const displayText = locations.slice(0, 4).join(", ") + (locations.length > 4 ? ", ..." : "");
        const fullText = locations.join(", ");

        return (
          <Tooltip title={fullText}>
            <Typography variant="body2" noWrap>
              {displayText}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "defaultLocation",
      headerName: "Default Location",
      flex: 1.5,
    },
    // {
    //   field: "viewPermissions",
    //   headerName: "View Permissions",
    //   flex: 1,
    //   renderCell: (params) => (
    //     <PermissionWrapper name='users.view_users'>
    //     <Button
    //       variant="contained"
    //       color="primary"
    //       size="small"
    //       // onClick={() => window.location.href = "/settings/role/permission"}
    //       onClick={()=>handleViewPermission(params.row.id,params.row.name,params.row.roleName)}
    //     >
    //       View
    //     </Button>
    //     </PermissionWrapper>
    //   ),
    // },
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <>
          <PermissionWrapper name='Users.edit_user'>
            <IconButton color="primary" onClick={() => handleEditUser(params.row)}>
              <EditIcon />
            </IconButton>
          </PermissionWrapper>
          {/* <PermissionWrapper name='Users.delete_user'>
      <IconButton color="error" onClick={() => handleDeleteUser(params.row.id)}>
        <DeleteIcon />
      </IconButton>
      </PermissionWrapper> */}
        </>
      ),
    },

  ];

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        backgroundColor: '#fff',
        overflow: 'auto',
      }}
    >
      <Stack spacing={2} p={3}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          {/* Left: Search */}
          <PermissionWrapper name='Users.list_users'>
            <TextField
              label="Search User"
              size="small"
              value={search}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {search && (
                      <IconButton onClick={handleClearSearch} edge="end">
                        <CloseIcon />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
              sx={{ flex: 1, maxWidth: '300px' }}
            />
          </PermissionWrapper>

          {/* Center: Title */}
          <Typography
            variant="h5"
            fontWeight={600}
            color="#0911A7"
            sx={{ flex: 1, textAlign: 'center' }}
          >
            User Management
          </Typography>

          {/* Right: Add Role Button */}
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <PermissionWrapper name='Users.add_user'>
              <Button
                startIcon={<AddIcon />}
                variant="contained"
                color="primary"
                onClick={handleAddUser}
              >
                Add User
              </Button>
            </PermissionWrapper>
          </Box>
        </Box>

        {/* DataGrid */}
        <Box
          sx={{
            height: 'calc(100vh - 300px)',
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'rgba(11, 67, 135, 1)',
              color: '#fff',
              fontWeight: 600,
            },
            '& .MuiDataGrid-menuIconButton': { color: '#fff' },
          }}
        >
          <PermissionWrapper name='Users.list_users'>
            <DataGridPro
              rows={filteredRows}
              columns={columns}
              disableRowSelectionOnClick
              hideFooterSelectedRowCount
            />
          </PermissionWrapper>
        </Box>

        {/* Dialog */}
        <AddUserForm
          open={openForm}
          handleClose={() => setOpenForm(false)}
          handleSubmit={handleSubmitForm}
          form={form}
          setForm={setForm}
          editUser={editUser}
        />

        {/* Snackbar */}
        <Snackbar
          open={snack.open}
          autoHideDuration={3000}
          onClose={() => setSnack((prev) => ({ ...prev, open: false }))}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={() => setSnack((prev) => ({ ...prev, open: false }))}
            severity={snack.severity}
            sx={{ width: '100%' }}
          >
            {snack.message}
          </Alert>
        </Snackbar>
      </Stack>
    </Box>
  );

}




